import React from 'react';

import './index.module.less';

import HalfScreenInfoModal from '@components/HalfScreenInfoModal';
import dadImage from './images/common_dad_default.png';
import momImage from './images/common_mom_default.png';
import grandpaImage from './images/common_grandpa_default.png';
import grandmaImage from './images/common_grandma_default.png';
import FridayService from '@services/friday';

interface IProps {
  onClose: () => void;
  onNameSelected: (name: string) => void;
  onCustomName: () => void;
}

type MenuItem = {
  image: string;
  name: string;
}

const menuData: MenuItem[] = [
  {
    image: dadImage, 
    name: '爸爸'
  },
  {
    image: momImage, 
    name: '妈妈'
  },
  {
    image: grandpaImage, 
    name: '爷爷'
  },
  {
    image: grandmaImage, 
    name: '奶奶'
  },
];

const CallNameMenu = (props: IProps) => {
  const renderMenuItems = () => {
    const items = menuData.map((item: MenuItem) => {
      const onItemSelected = () => {
        FridayService.addEvent('application_binding_apply_for_binding_select_identity_popup_click',  {type: item.name});
        props.onNameSelected && props.onNameSelected(item.name);
        props.onClose && props.onClose();
      }
  
      return (
        <div key={item.name} className='flex' styleName='item-container' onClick={onItemSelected}>
          <img src={item.image} alt="" styleName='item-icon'/>
          <p>{item.name}</p>
          <i styleName='right-arrow' className="iconfont icon-tubiaoyanse"/> 
        </div>
      )
    });
    return (
      <div className='flex' styleName='menu-content'>
        {items}
      </div>
    );
  }

  const onCustomNameInput = () => {
    FridayService.addEvent('application_binding_apply_for_binding_select_identity_popup_click',  {type: '自定义'});
    props.onCustomName && props.onCustomName();
    props.onClose && props.onClose();
  }

  return (  
    <HalfScreenInfoModal
      height="9.34rem"
      onClose={ props.onClose }
      hideCloseBtn={ true }
    >
      <div className='flex' styleName='menu-container'>
        <div styleName='title'>您是孩子的</div>
        {renderMenuItems()}
        <div className='flex' styleName='item-container' onClick={() => onCustomNameInput()}>
          <i styleName='add-icon' className="iconfont icon-jiahao"/> 
          <p>自定义亲属关系</p>
          <i styleName='right-arrow' className="iconfont icon-tubiaoyanse"/> 
        </div>
      </div>
    </HalfScreenInfoModal>
  )
}

export default CallNameMenu;